import { render, staticRenderFns } from "./EdenPageHeader.vue?vue&type=template&id=562826f6&scoped=true"
import script from "./EdenPageHeader.vue?vue&type=script&lang=js"
export * from "./EdenPageHeader.vue?vue&type=script&lang=js"
import style0 from "./EdenPageHeader.vue?vue&type=style&index=0&id=562826f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562826f6",
  null
  
)

export default component.exports